export const authRoles = {
  //sa: ['SA'], // Only Super Admin has access
  admin: ['SA', 'ADMIN', 'ROLE_ADMIN'], // Only SA & Admin has access
  user: ['USER', 'ROLE_USER'], // Only SA & Admin & Editor has access
  //   editor: ['SA', 'ADMIN', 'EDITOR'], // Only SA & Admin & Editor has access
  //   guest: ['SA', 'ADMIN', 'EDITOR', 'GUEST'], // Everyone has access
};
